import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Practitioner } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner";
import { PractitionerStatus } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner-status";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";

export class PractitionerForm {
  private formGroup: UntypedFormGroup;

  constructor() {
    this.formGroup = new UntypedFormGroup({
      id: new UntypedFormControl(""),
      name: new UntypedFormControl("", Validators.required),
      stateAcronym: new UntypedFormControl(null, Validators.required),
      registration: new UntypedFormControl("", Validators.required),
      status: new UntypedFormControl(null, Validators.required),
      specialties: new UntypedFormControl([]),
    });
  }

  public getFormGroup(): UntypedFormGroup {
    return this.formGroup;
  }

  public loadFormGroup(practitioner: Practitioner, states: StateAcronym[], status: PractitionerStatus[]): void {
    const state = states.find((item) => item.getValue() === practitioner.getStateAcronym().getValue());
    const practitionerStatus = status.find((item) => item.getKey() === practitioner.getStatus().getKey());
    this.formGroup.patchValue({
      id: practitioner.getKey(),
      name: practitioner.getName(),
      stateAcronym: state,
      registration: practitioner.getRegistration(),
      status: practitionerStatus,
      specialties: practitioner.getSpecialties(),
    });
  }

  public parseFormGroup(): Practitioner {
    const practitioner = new Practitioner();
    practitioner.setKey(this.formGroup.value.id);
    practitioner.setName(this.formGroup.value.name);
    practitioner.setStateAcronym(this.formGroup.value.stateAcronym);
    practitioner.setRegistration(this.formGroup.value.registration);
    practitioner.setStatus(this.formGroup.value.status);
    practitioner.setSpecialties(this.formGroup.value.specialties);
    return practitioner;
  }
}
